/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';
// S29: a aba por caminho do legado (router.tsx:2000-2009) vira `?tab=`.
export const Route = createFileRoute('/_app/seguranca/grupos/$groupId/membros')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/seguranca/grupos/$groupId', params, search: { tab: 'membros' } });
  },
});
